import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56128b27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "title page-title" }
const _hoisted_3 = { class: "filter scrollbar-flex-content" }
const _hoisted_4 = { class: "button-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search fas" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Filtros de búsqueda", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search el-input__icon fas" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-minus fas" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-check fas" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-trash fas" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-plus fas" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_generated_alert_list_component = _resolveComponent("generated-alert-list-component")!
  const _component_page_buttons_component = _resolveComponent("page-buttons-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, { class: "header" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("text.generatedAlerts")), 1)
          ]),
          _createVNode(_component_el_scrollbar, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.canSeepPoints)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "btn",
                        round: "",
                        type: _ctx.tipoSampling,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeSamplingPoint()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.estimatedParam")), 1)
                        ]),
                        _: 1
                      }, 8, ["type"]))
                    : _createCommentVNode("", true),
                  (_ctx.canSeeStations)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        class: "btn",
                        round: "",
                        type: _ctx.tipoStation,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeStation()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.stations")), 1)
                        ]),
                        _: 1
                      }, 8, ["type"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_popover, {
                    placement: "bottom",
                    width: 250,
                    visible: _ctx.visibleSearch,
                    trigger: "hover"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "secondary",
                        circle: "",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.visibleSearch = !_ctx.visibleSearch))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createVNode(_component_el_input, {
                        class: "search",
                        modelValue: _ctx.searchQuery,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchQuery) = $event)),
                        placeholder: "Nombre de la alerta"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.selectedSamplingPoint,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedSamplingPoint) = $event)),
                        filterable: "",
                        placeholder: "Punto de monitorización",
                        class: "search",
                        onChange: _ctx.loadParameters
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.samplingPoints, (point) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: point.id,
                              label: point.name,
                              value: point.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"]),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.selectedParameters,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedParameters) = $event)),
                        filterable: "",
                        placeholder: "Parámetros",
                        class: "search",
                        multiple: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameters, (param) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: param.id,
                              label: param.name,
                              value: param.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_row, {
                        class: "row-btn",
                        width: "100%"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            class: "btn",
                            type: "primary",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.search()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("btn.search")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"]),
                  _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "dark",
                    content: _ctx.$t('tooltip.refresh'),
                    placement: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "secondary",
                        icon: _ctx.Refresh,
                        circle: "",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.refresh()))
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_generated_alert_list_component, {
        typeAlert: _ctx.seeType,
        query: _ctx.query,
        queryHistory: _ctx.queryHistory,
        querySamPoint: _ctx.selectedSamplingPoint,
        queryParams: _ctx.selectedParameters,
        "start-date": _ctx.startDateFilter,
        "end-date": _ctx.endDateFilter,
        selectedAll: _ctx.selectedAll,
        ref: "generatedAlertList",
        onUpdateSelectedItems: _ctx.updateSelectedItems,
        onUpdateQuery: _ctx.updateQuery,
        onSearchNotifications: _ctx.serchAlertNotifications
      }, null, 8, ["typeAlert", "query", "queryHistory", "querySamPoint", "queryParams", "start-date", "end-date", "selectedAll", "onUpdateSelectedItems", "onUpdateQuery", "onSearchNotifications"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_page_buttons_component, null, {
        default: _withCtx(() => [
          (_ctx.selectedAll)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "dark",
                content: _ctx.$t('btn.unselectAll'),
                placement: "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "btn",
                    type: "primary",
                    size: "large",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectAll())),
                    circle: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["content"]))
            : (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1,
                effect: "dark",
                content: _ctx.$t('btn.selectAll'),
                placement: "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "btn",
                    type: "primary",
                    size: "large",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectAll())),
                    circle: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["content"])),
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: _ctx.$t('btn.deleteSelectedAlert'),
            placement: "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                type: "primary",
                size: "large",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteAlert())),
                circle: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"]),
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: _ctx.$t('btn.create'),
            placement: "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                type: "primary",
                size: "large",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.redirectCreate())),
                circle: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _: 1
      })
    ])
  ]))
}